import { useMemo } from 'react';
import { SummaryFormValues } from '../../../components/ControlLayout/hooks/useSummaryForm';
import { useSummaryFormContext } from '../../../components/ControlLayout/ControlLayout';
import { useGetRiskColor } from './useGetRiskColor';

type RiskRow = {
  id: number;
  risk: keyof SummaryFormValues;
  description: {
    title: string;
    text: string;
  };
};

export const useRiskTableData = () => {
  const { watch } = useSummaryFormContext();

  const deviations: RiskRow[] = [
    {
      id: 1,
      risk: 'shellProtectionRisk',
      description: {
        title: 'Skalskydd/inhägnad',
        text: 'Kontroll av skalskydd/avgränsning kring byggarbetsplatsen.',
      },
    },
    {
      id: 2,
      risk: 'workEnvironmentRisk',
      description: {
        title: 'Arbetsmiljö',
        text: 'Kontroll av arbetsmiljön på arbetsplatsen.',
      },
    },
    {
      id: 3,
      risk: 'workRegisterRisk',
      description: {
        title: 'Elektronisk personalliggare',
        text: 'Kontroll av elektronisk personalliggare, hård och mjukvara.',
      },
    },
    {
      id: 4,
      risk: 'identificationRisk',
      description: {
        title: 'Avsaknad av giltig legitimation',
        text: 'Personkontroll av giltig legitimation.',
      },
    },
    {
      id: 5,
      risk: 'id06DeviationsRisk',
      description: {
        title: 'Brott mot ID06 regelverk',
        text: 'Personkontroll avseende ID06.',
      },
    },
    {
      id: 6,
      risk: 'safetyEquipmentRisk',
      description: {
        title: 'Personlig säkerhetsutrustning',
        text: 'Personlig säkerhetsutrustning i enlighet med arbetsplatsens krav på individen.',
      },
    },
    {
      id: 7,
      risk: 'workPermitRisk',
      description: {
        title: 'Kontroll av arbetstillstånd och uppehållshandlingar',
        text: 'I förekommande fall, kontroll av arbetstillstånd samt uppehållshandlingar.',
      },
    },
    {
      id: 8,
      risk: 'preApprovedSubcontractorRisk',
      description: {
        title: 'Förgodkända UE',
        text: 'Inventering av underentreprenörer och i förekommande fall, kontroll gentemot projektbeställarens förteckning av förgodkända UE. Kontroll mot ID06 Bolagsdeklaration.',
      },
    },
    {
      id: 9,
      risk: 'secondmentRegulationsRisk',
      description: {
        title: 'Utstationeringsregelverket',
        text: 'Kontroll av utländska bolag mot utstationeringsregistret.',
      },
    },
    {
      id: 10,
      risk: 'intoxicationRisk',
      description: {
        title: 'Onykterhet och drogpåverkan',
        text: 'Tecken på onykterhet och drogpåverkan.',
      },
    },
    {
      id: 11,
      risk: 'otherRisk',
      description: {
        title: 'Övrig kontrollverksamhet',
        text: 'Ö̈vrig kontrollverksamhet (disk rimineringsrisker, misstankar om boende på arbetsplats).',
      },
    },
  ];

  const columns = useMemo(() => {
    return [
      {
        Header: 'ID#',
        accessor: 'id',
      },
      {
        Header: 'Riskvärdering',
        accessor: 'risk',
      },
      {
        Header: 'Beskrivning',
        accessor: 'description',
      },
    ] as const;
  }, []);

  const data = useMemo(() => {
    return deviations.map((row) => {
      const value = Number(watch(row.risk));
      return {
        id: row.id,
        risk: row.risk,
        color: useGetRiskColor(value),
        description: row.description,
      };
    });
  }, [watch()]);

  return { columns, data };
};
